require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./rglements-2-3-2.json") })
        }
      }, "path---rglements-2-3-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---rglements-2-3-2!./.cache/json/rglements-2-3-2.json
// module id = 553
// module chunks = 231608221292675